// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BMap_cpyCtrl {\n  display: none;\n}\n.anchorBL {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
